import {
  GET_USER_DATA_URL,
  IS_DEV_ENV,
  PROMO_CODE_VERIFY_URL,
  REQUEST_ENROLLMENT_START_COUNT_URL,
  SMARTY_AUTOSUGGEST_URL,
  USER_ENTITY_BASE_URL,
  VERIFY_SCAN_ID_URL,
  ZIPCODE_CITY_STATE_URL,
} from 'consts/appConsts';
const { SMARTY_KEY } = window.Chime.config;
import errorMessages from 'consts/errorMessageConsts';

import { LOG_LEVELS, loggerHelper } from 'utils/logger/loggerHelper';
import { getAnonymousId } from 'utils/segment';

import fetchWrapper from './fetchWrapper';
import handleServerResponse, {
  catchRequestError,
} from './handleServerResponse';

export const createUser = data => {
  return submitUserFormData({
    data,
    url: USER_ENTITY_BASE_URL,
    requestType: 'POST',
  });
};

export const updateUser = (data, userId) => {
  return submitUserFormData({
    data,
    url: `${USER_ENTITY_BASE_URL}/${userId}`,
    requestType: 'PUT',
  });
};

export const submitUserFormData = ({ data, url, requestType }) => {
  return fetchWrapper({
    url,
    requestType,
    options: {
      retry: true,
      body: JSON.stringify(data),
    },
  })
    .then(handleServerResponse)
    .catch(err => catchRequestError(err, 'Error posting to enrollment'));
};

export const getCurrentUserSessionData = (extraHeaders = {}) => {
  return fetchWrapper({
    url: GET_USER_DATA_URL,
    requestType: 'GET',
    options: {
      retry: true,
    },
    extraHeaders,
  })
    .then(handleServerResponse)
    .catch(err => {
      catchRequestError(err, 'Error fetching user session data');
    });
};

export const verifyScanId = ({ data }) =>
  fetchWrapper({
    url: VERIFY_SCAN_ID_URL,
    requestType: 'POST',
    options: {
      retry: true,
      body: JSON.stringify(data),
    },
  })
    .then(handleServerResponse)
    .then(res => {
      if (res.status === 401) {
        loggerHelper({
          message: 'Unauthenticated attempt to verify scan_id_inquiry',
          info: res,
        });
      }

      return res;
    })
    .catch(err => catchRequestError(err, 'Error verifying scan_id_inquiry'));

export const getZipCodeCityState = zipcode => {
  return fetchWrapper({
    url: ZIPCODE_CITY_STATE_URL,
    requestType: 'POST',
    options: {
      body: JSON.stringify({
        zip_code: zipcode,
      }),
    },
  })
    .then(handleServerResponse)
    .catch(err => {
      loggerHelper({
        level: LOG_LEVELS.ERROR,
        message: 'Error fetching ZIP',
        info: err,
      });

      return {
        error: errorMessages.GENERAL_ERROR_MESSAGE,
        errorCode: null,
      };
    });
};

export const requestEnrollmentStartCountEndpoint = () => {
  return fetchWrapper({
    url: REQUEST_ENROLLMENT_START_COUNT_URL,
    requestType: 'POST',
    options: {
      retry: false,
      body: JSON.stringify({ segment_anonymous_id: getAnonymousId() }),
    },
  });
};

export const requestPromoCodeVerify = promoCode => {
  return fetchWrapper({
    url: PROMO_CODE_VERIFY_URL,
    requestType: 'POST',
    options: {
      body: JSON.stringify({ promo_code_string: promoCode }),
    },
  });
};

export const requestSmartyAutosuggestions = (
  searchString,
  selectedAddress = null
) => {
  // prefer_geolocation = city --> uses sender's IP to determine location, then automatically adds the city and state to the prefer_cities value
  // source = postal --> will limit the results to postal addresses only
  const smartyConfigurations = '&prefer_geolocation=city&source=postal';
  // Removes USPS blocked chars to allow autosuggest to work better - https://pe.usps.com/text/pub28/28c3_019.htm
  const removeSpecialChars = searchString.replace(/[*,.()""::'@&-]/g, '');
  const encodedSearchString = encodeURIComponent(removeSpecialChars);
  let combinedUrl = `${SMARTY_AUTOSUGGEST_URL}?search=${encodedSearchString}${smartyConfigurations}`;
  if (IS_DEV_ENV) {
    combinedUrl += `&key=${SMARTY_KEY}`;
  }

  if (selectedAddress) {
    const encodedSelectedAddressString = encodeURIComponent(selectedAddress);

    combinedUrl += `&selected=${encodedSelectedAddressString}`;
  }

  return fetchWrapper({
    url: combinedUrl,
    requestType: 'GET',
    customHeaders: {}, // We need this because Smarty doesn't allow our normal headers
    isDifferentOrigin: true,
  }).then(res => {
    return res.json().then(resData => {
      const newResData = resData || {};
      if (res.status !== 200 && res.status !== 201) {
        newResData.errorCode = res.status;
      } else {
        newResData.status = res.status;
      }
      return newResData;
    });
  });
};
